<template>
  <div class="map-items">
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
    <map-popup-item image="product_example"></map-popup-item>
  </div>
</template>
<script>
import MapPopupItem from "./map-popup-item.vue";
import $ from "jquery";

export default {
  name: "map-products",
  components: { MapPopupItem },
  mounted() {
    var divs = document.getElementsByClassName("map-popup-item");
    function getRandomNumber(min, max) {
      return Math.random() * (max - min) + min;
    }
    var randomTop = 0;
    var randomLeft = 0;
    for (var i = 0; i < divs.length; i++) {
      var thisDiv = divs[i];
      thisDiv.classList.add("item-" + i);
      randomTop = getRandomNumber(0, 100);
      randomLeft = getRandomNumber(0, 100);
      thisDiv.style.top = randomTop + "%";
      thisDiv.style.left = randomLeft + "%";
    }
    function random(n) {
      return Math.floor(Math.random() * n);
    }
    var images = $(".map-popup-item");
    var n = images.length;
    function show(item, t_time, w_time) {
      images.eq(item).addClass("visible");
      setInterval(function() {
        images.eq(item).removeClass("visible");
        item = random(n);
        images.eq(item).addClass("visible");
      }, 2 * t_time + w_time);
    }
    show(random(n), 500, 3000);
    show(random(n), 600, 4500);
    show(random(n), 400, 3500);
    show(random(n), 400, 3000);
    show(random(n), 600, 5500);
    show(random(n), 600, 3500);
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.map-items {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;

  .map-popup-item {
    position: absolute;
    top: 100px;
    left: 100px;
    transition: all 1s ease-in-out;
    opacity: 0;

    &.visible {
      opacity: 1;
    }
  }
}
</style>
